import { useRef } from "react";

const LEN = 6;

// Mobile-friendly 6-box OTP input: auto-advance, backspace navigation, full-paste, arrow keys.
export function OtpInput({ value, onChange, onComplete, disabled = false, testId = "otp" }) {
  const refs = useRef([]);
  const digits = (value || "").padEnd(LEN, " ").slice(0, LEN).split("").map((c) => (c === " " ? "" : c));

  const emit = (arr) => {
    const v = arr.join("").replace(/\D/g, "").slice(0, LEN);
    onChange(v);
    if (v.length === LEN && onComplete) onComplete(v);
  };

  const setAt = (i, ch) => {
    const next = [...digits];
    next[i] = ch;
    emit(next);
  };

  const handleChange = (i, raw) => {
    const ch = (raw || "").replace(/\D/g, "").slice(-1);
    if (!ch) return;
    setAt(i, ch);
    if (i < LEN - 1) refs.current[i + 1]?.focus();
  };

  const handleKeyDown = (i, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      if (digits[i]) setAt(i, "");
      else if (i > 0) { refs.current[i - 1]?.focus(); setAt(i - 1, ""); }
    } else if (e.key === "ArrowLeft" && i > 0) refs.current[i - 1]?.focus();
    else if (e.key === "ArrowRight" && i < LEN - 1) refs.current[i + 1]?.focus();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, LEN);
    if (!pasted) return;
    emit(pasted.split(""));
    refs.current[Math.min(pasted.length, LEN - 1)]?.focus();
  };

  return (
    <div className="flex gap-2 justify-between" onPaste={handlePaste} data-testid={`${testId}-input`}>
      {Array.from({ length: LEN }).map((_, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={1}
          disabled={disabled}
          value={digits[i] || ""}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onFocus={(e) => e.target.select()}
          data-testid={`${testId}-box-${i}`}
          className="h-12 w-12 sm:h-14 sm:w-14 text-center text-xl font-bold border border-slate-300 rounded-md focus:border-[#0B3D91] focus:ring-2 focus:ring-[#0B3D91]/20 outline-none disabled:bg-slate-100 disabled:opacity-60"
        />
      ))}
    </div>
  );
}
